export default "__VITE_ASSET__DjVE4wT___";